module.exports = __webpack_public_path__ + "img/esc_1_act_5.46ed72f3.png";